//Falta refactor importante sobre cosas que no se usan,
// Falta actualizar contadores en los Chips
// Hay que ver bien cómo hacer los filtros (filtrar frontend o backend), y que la info este bien. Hay filtros implementados
// pero no los uso. Hay que ver exportar.
// Ver qué pasa con las comunas harcodeadas, para que están.

import React, { useState, useEffect } from "react";
import axios from "../customAxios.js";
import {
  Alert,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import es from "date-fns/locale/es";
import { mapStatus } from "../utils/functions";
import CustomTableNew from "../components/CustomTableNew.jsx";
import { dateToDatabase } from "../utils/functions";
import LoadingComponent from "../components/LoadingComponent.jsx";
import { PDFDocument } from "pdf-lib";
import { getPublicS3Url } from "../utils/s3Utils.js";

function OrdersNew(props) {
  //values to control pagination of the component table
  const [page, setPage] = useState(
    localStorage.getItem("ordersFilter")
      ? JSON.parse(localStorage.getItem("ordersFilter")).page
      : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("ordersFilter")
      ? JSON.parse(localStorage.getItem("ordersFilter")).rowsPerPage
      : 20
  );

  //data that will be set on every page change and filter set
  const [pageData, setPageData] = useState();
  const [loadingPageData, setLoadingPageData] = useState(true);

  // const [loading, setLoading] = useState(false);
  const daysOffset = props.daysOffset;

  const [servicesTypes, setServicesTypes] = useState([]);

  //filter values of the table
  const [startDate, setStartDate] = useState(
    localStorage.getItem("ordersFilter")
      ? new Date(JSON.parse(localStorage.getItem("ordersFilter")).startDate)
      : new Date(new Date().setDate(new Date().getDate() - daysOffset))
  );
  const [endDate, setEndDate] = useState(
    localStorage.getItem("ordersFilter")
      ? new Date(JSON.parse(localStorage.getItem("ordersFilter")).endDate)
      : new Date()
  );
  const [serviceFilter, setServiceFilter] = useState(
    localStorage.getItem("ordersFilter")
      ? JSON.parse(localStorage.getItem("ordersFilter")).serviceFilter
      : "all"
  );
  const [search, setSearch] = useState(
    localStorage.getItem("ordersFilter")
      ? JSON.parse(localStorage.getItem("ordersFilter")).search
      : ""
  );

  //aux values for delay on text search fields
  const [auxSearcher, setAuxSearcher] = useState(
    localStorage.getItem("ordersFilter")
      ? JSON.parse(localStorage.getItem("ordersFilter")).search
      : ""
  );

  const [counters, setCounters] = useState({});
  const [counterLabels, setCounterLabels] = useState();
  // const [dateRefresh, setDateRefresh] = useState(false);

  const [errorOnRetrieveData, setErrorOnRetrieveData] = useState();
  const [comunas, setComunas] = useState([]);
  const [isInitialRender, setIsInitialRender] = useState(true);

  //useState to save user type
  const [userType, setUserType] = useState(props.mode);

  //useState to catch when general data is already fetched
  const [generalParamsFetched, setGeneralParamsFetched] = useState(false);

  //useState to count the number of orders filtered by backend
  const [ordersCount, setOrdersCount] = useState(0);

  //useState for dowload labels status
  const [loadingDownloadLabels, setLoadingDownloadLabels] = useState(false);

  //define url to call on backend depending on user type
  let user_type_url_path = "";
  if (userType === "seller") {
    user_type_url_path = "filtered_orders_seller_new/";
  } else {
    user_type_url_path = "filtered_orders_new/";
  }

  useEffect(() => {
    //if localStorage "ordersFilter" does not exist, set page to 0
    if (!localStorage.getItem("ordersFilter")) {
      setPage(0);
    }
    //if is on useEffect not on initial render, set page 0
    if (isInitialRender) {
      setIsInitialRender(false);
    } else {
      setPage(0);
    }
  }, [startDate, endDate, serviceFilter, search, rowsPerPage]);

  useEffect(() => {
    if (!loadingPageData) {
      setLoadingPageData(true);
    }
    fetchOrders();
    //save on localStorage the filter and page values of orders
    localStorage.setItem(
      "ordersFilter",
      JSON.stringify({
        startDate,
        endDate,
        serviceFilter,
        search,
        page,
        rowsPerPage,
      })
    );
  }, [startDate, endDate, serviceFilter, search, rowsPerPage, page]);

  //useEffect to catch auxSearcher changes, and triger a function every 2 seconds that dont change
  useEffect(() => {
    // Delayed search function
    const delayedSearch = (value) => {
      // Your search logic goes here
      setSearch(value);
    };
    if (!loadingPageData) {
      setLoadingPageData(true);
    }
    // Timer variable for setTimeout
    let timer;

    // Set a delay of 2 seconds before executing the search
    const delay = 1500;

    // Clear the previous timer when auxSearcher changes
    clearTimeout(timer);

    // Set a new timer for delayed search
    timer = setTimeout(() => {
      delayedSearch(auxSearcher);
    }, delay);

    // Clean up the timer on component unmount or when auxSearcher changes
    return () => {
      clearTimeout(timer);
    };
  }, [auxSearcher]);

  const searchParams = () => {
    return {
      start_date: dateToDatabase(startDate),
      end_date: dateToDatabase(endDate),
      order_type: serviceFilter,
      search: search,
    };
  };

  async function getOrdersDeliveries() {
    let labelUrls = [];

    try {
      const mode = userType === "seller" ? "seller" : "operator";
      const { data } = await axios.get("orders_deliveries/", {
        params: {
          start_date: dateToDatabase(startDate),
          end_date: dateToDatabase(endDate),
          mode: mode,
        },
      });

      labelUrls = data.orders_deliveries
        .map((order) => {
          if (order?.delivery?.label) {
            try {
              const url = new URL(order.delivery.label);
              const s3Key = url.pathname.substring(1);

              return getPublicS3Url(
                process.env.REACT_APP_S3_BUCKET_NAME,
                s3Key
              );
            } catch (parseError) {
              console.error(
                `Error al convertir url: ${order.delivery.label} ${parseError}`
              );
              return null;
            }
          }
          return null;
        })
        .filter((url) => url !== null);
    } catch (error) {
      console.error("Error:", error);
    }
    return labelUrls;
  }

  async function handleDownloadLabels() {
    setLoadingDownloadLabels(true);
    const labelUrls = await getOrdersDeliveries();

    if (labelUrls.length > 0) {
      try {
        const pdfBytesArray = await Promise.all(
          labelUrls.map((url) => fetch(url).then((res) => res.arrayBuffer()))
        );

        const mergedPdfDoc = await PDFDocument.create();
        for (const pdfBytes of pdfBytesArray) {
          const pdfDoc = await PDFDocument.load(pdfBytes);
          const copiedPages = await mergedPdfDoc.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdfDoc.addPage(page));
        }

        const mergedPdfBytes = await mergedPdfDoc.save();
        const mergedBlob = new Blob([mergedPdfBytes], {
          type: "application/pdf",
        });
        const mergedUrl = URL.createObjectURL(mergedBlob);

        window.open(mergedUrl, "_blank");
      } catch (error) {
        console.error("Error:", error);
      }
      setLoadingDownloadLabels(false);
    } else {
      console.log("No labels to download.");
      setLoadingDownloadLabels(false);
    }
  }

  //function to fetch all general parameters that do not depends on the page and rowsPerPage
  async function fetchGeneralParams() {
    try {
      const {
        data: { status_counters, order_types, status_choices },
      } = await axios.get(`general_params/${user_type_url_path}`, {
        params: searchParams(),
      });
      setCounters(status_counters);
      setOrdersCount(status_counters.total_orders);
      setServicesTypes(order_types);
      setCounterLabels(status_choices);
      setErrorOnRetrieveData();
      setGeneralParamsFetched(true);
    } catch (error) {
      console.error(`error: ${error}`);
      setErrorOnRetrieveData(
        "Ocurrió un error al obtener los contadores y opciones de filtro"
      );
    }
  }

  //function to fetch the page data depending on filters, and pagination params
  async function fetchOrders() {
    setLoadingPageData(true);
    const search_params_fetch_orders = {
      start_date: dateToDatabase(startDate),
      end_date: dateToDatabase(endDate),
      order_type: serviceFilter,
      search: search,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    try {
      const { data } = await axios.get(user_type_url_path, {
        params: search_params_fetch_orders,
      });
      setPageData(data.orders);
      setErrorOnRetrieveData();
    } catch (error) {
      console.error(`error: ${error}`);
      setPageData([]);
      setErrorOnRetrieveData("Ocurrió un error al obtener las órdenes");
    } finally {
      setLoadingPageData(false);
    }
  }

  useEffect(() => {
    fetchGeneralParams();
  }, [startDate, endDate, serviceFilter, search]);

  useEffect(() => {
    const fetchComunas = async () => {
      setComunas(["comuna1", "comuna2", "comuna3"]);
    };
    fetchComunas();
  }, []);

  let headerTable = [
    { columnName: "Id Referencia", dbName: "reference_id", enabled: true },
    {
      columnName: "Nombre Seller",
      dbName: "seller_company_social_reason",
      enabled: true,
    },
    { columnName: "Destinatario", dbName: "recipient", enabled: true },
    { columnName: "Dirección", dbName: "address", enabled: true },
    { columnName: "Comuna", dbName: "comuna_name", enabled: true },
    { columnName: "Fecha ingreso", dbName: "creation_date", enabled: true },
    { columnName: "Tipo de orden", dbName: "order_type", enabled: true },
    {
      columnName: "Proveedor encargado",
      dbName: "delivery_courier_name",
      enabled: true,
    },
    { columnName: "Estado", dbName: "status", enabled: true },
    { columnName: "Detalles", dbName: "details", enabled: true },
  ];

  if (userType === "seller") {
    headerTable = [
      { columnName: "Id Referencia", dbName: "reference_id", enabled: true },
      { columnName: "Id Go-ex", dbName: "id_goex", enabled: true },
      {
        columnName: "Fecha de ingreso",
        dbName: "creation_date",
        enabled: true,
      },
      { columnName: "Canal", dbName: "", enabled: true },
      { columnName: "Destinatario", dbName: "recipient", enabled: true },
      { columnName: "Tipo de entrega", dbName: "order_type", enabled: true },
      { columnName: "Estado", dbName: "status", enabled: true },
      { columnName: "Detalles", dbName: "details", enabled: true },
    ];
  }
  if (generalParamsFetched) {
    return (
      <>
        <Grid item xs={12}>
          <h1>Órdenes</h1>
        </Grid>

        <Grid container>
          <Grid item xs={12} className="chip-btn-container">
            <Grid item xs={8}>
              <Chip
                label={`${
                  counters && counters.total_orders ? counters.total_orders : 0
                } Solicitudes en total`}
                variant="contained"
              />
              {counterLabels &&
                counterLabels.map((label) => (
                  <Chip
                    label={`${counters[label] || 0} ${mapStatus(label)}`}
                    variant="contained"
                    // className={label}
                    key={label}
                  />
                ))}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm className="flex-left filters-container">
          <div className="row-container request-search-container">
            <Grid container>
              <Grid item xs={6} sm="auto" className="input-date-filter">
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={es}
                >
                  {/* {window.innerWidth > 768 ? ( */}
                  <DatePicker
                    label="Fecha de inicio"
                    value={startDate}
                    onChange={(newValue) => {
                      if (endDate < newValue) {
                        let newEndDate = new Date(newValue);
                        newEndDate.setDate(newEndDate.getDate() + daysOffset);
                        setEndDate(newEndDate);
                      }
                      setStartDate(newValue);
                    }}
                    // disabled={ordersFiltered === undefined}
                    className="mg-r-10"
                  />
                </LocalizationProvider>
              </Grid>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
              >
                <DatePicker
                  label="Fecha de fin"
                  value={endDate}
                  onChange={(newValue) => {
                    if (newValue < startDate) {
                      let newStartDate = new Date(newValue);
                      newStartDate.setDate(newStartDate.getDate() - daysOffset);
                      setStartDate(newStartDate);
                    }
                    setEndDate(newValue);
                    // setDateRefresh(true);
                  }}
                  // disabled={startDate === null || ordersFiltered === undefined}
                  disabled={startDate === null}
                  className="mg-r-10 mg-l-10"
                />
              </LocalizationProvider>
              <Grid item xs={6} sm="auto" className="input-service-filter">
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="select-service-filte">
                    Tipo de servicio
                  </InputLabel>
                  <Select
                    value={serviceFilter}
                    onChange={(e) => {
                      setServiceFilter(e.target.value);
                    }}
                    input={<OutlinedInput id="select-service-filter" />}
                    IconComponent={() => (
                      <i className="material-icons-outlined">expand_more</i>
                    )}
                    // disabled={ordersFiltered === undefined}
                  >
                    <MenuItem key={"all"} value={"all"}>
                      Todos
                    </MenuItem>
                    {Object.entries(servicesTypes).map(
                      ([kind, label], index) => (
                        <MenuItem key={index} value={kind}>
                          {label}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <TextField
                variant="outlined"
                label="Buscar"
                name="search"
                value={auxSearcher}
                onChange={(e) => {
                  setAuxSearcher(e.target.value);
                }}
                className="mg-l-10"
                disabled={false}
              />

              <div>
                <Button
                  type="submit"
                  variant="outlined"
                  className="mg-l-10"
                  onClick={handleDownloadLabels}
                  disabled={loadingDownloadLabels} // Disable the button while loading
                  startIcon={
                    loadingDownloadLabels ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : null
                  } // Show loading indicator
                >
                  {loadingDownloadLabels
                    ? "Cargando..."
                    : "Descargar Etiquetas"}
                </Button>
              </div>
            </Grid>
          </div>
        </Grid>

        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <>
              {errorOnRetrieveData ? (
                <Alert severity="error">{errorOnRetrieveData}</Alert>
              ) : (
                <CustomTableNew
                  searchParams={searchParams}
                  user_type_url_path={user_type_url_path}
                  search={search}
                  filterByDate={startDate !== null && endDate !== null}
                  headerTable={headerTable}
                  selected={"none"}
                  setSelected={"none"}
                  openCollapseButton={true}
                  openCollapseTooltip={"Ver más"}
                  openCollapseIcon={
                    <i className="material-icons-outlined icon-actions-panel-test">
                      add_circle_outline
                    </i>
                  }
                  collapseType={"all-orders"}
                  hasPagination={true}
                  orderTypes={servicesTypes}
                  editable={true}
                  comunas={comunas}
                  filterStates={{ startDate, endDate, serviceFilter, search }}
                  totalCount={ordersCount}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  pageData={pageData}
                  setPageData={setPageData}
                  loadingPageData={loadingPageData}
                />
              )}
            </>
          </Grid>
        </Grid>
      </>
    );
  } else {
    <LoadingComponent />;
  }
}

export default OrdersNew;
